import {Component} from "../Component";
import {element} from "../CustomElement";
import {icons} from "../../icons/Icons";
import {Page} from "../../components/flipp-page/Page";

@element("flipp-data-success")
export class CCPAFormSuccess extends Component<{}, void> {
	render() {
		return <Page show="flyers">
			<div class="success-wrapper">
				<div class="success-inner">
					<div class="success-text-wrapper">
						<div class="success-image">
							<img class="myDataSuccess" src="https://f.wishabi.net/creative/Distribution/images/icons/myDataSuccess.svg" alt=""/>
						</div>
						<div class="success-header">Request submitted successfully</div>
						<div class="success-text">Your request was submitted successfully. <br/> We will send you an email shortly.</div>
					</div>
				</div>
			</div>
		</Page>;
	}
}
